import { render, staticRenderFns } from "./PageListByTestClass.vue?vue&type=template&id=1677f9f7&scoped=true"
import script from "./PageListByTestClass.vue?vue&type=script&lang=ts"
export * from "./PageListByTestClass.vue?vue&type=script&lang=ts"
import style0 from "./PageListByTestClass.vue?vue&type=style&index=0&id=1677f9f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1677f9f7",
  null
  
)

export default component.exports